/* =========================================
   TEEINBLUE STICKY (HORIZON / HalloGeschenk.de)
   Mobile portrait only • Portal + Placeholder • Zoom 50–300% • Pan Up/Down
   Auto-Open beim Scrollen nach unten • Auto-Close beim Scrollen nach oben
   Manuelles Schließen via X • Wiedereinblenden via Zoom-Button

   ----------------------------------------------------------------
   HERKUNFT DIESER DATEI — bitte vor Änderungen lesen
   ----------------------------------------------------------------
   Das ist die ausgereifte Fassung aus dem Theme "Concept Sticky Master"
   (Stand 20.08.2026, 39.664 Bytes), portiert auf Horizon. In Horizon lag
   bis zum 01.09.2026 ein deutlich älterer Stand (19.037 Bytes) — der mit
   dem kurzen Auf-und-wieder-Zu als Teaser. Diese Fassung hier hat gar
   keinen Teaser: sie öffnet beim Runterscrollen und schließt beim
   Hochscrollen, mit Hysterese (siehe autoToggleOnScroll).

   Beim Portieren waren genau ZWEI Stellen Concept-spezifisch. Beide
   hätten in Horizon dazu geführt, dass das Skript wortlos aussteigt:

   [HORIZON-1] galleryWrapperSelector war ".product__gallery" — diese
               Klasse gibt es in Horizon nicht. Horizon rendert das
               Custom-Element <media-gallery>. Nachgemessen: die
               teeinblue-Galerie .tee-gallery-content liegt darin.

   [HORIZON-2] Die Erkennung "ist das ein teeinblue-Produkt?" lief über
               window.json_product bzw. window.HGDE_PRODUCT_SKUS und
               suchte SKUs mit "263". Beide Variablen sind in Horizon
               undefined — die SKU-Liste wäre leer geblieben, die Prüfung
               false, und das Skript hätte in Zeile ~90 per return
               abgebrochen. Kein Fehler in der Konsole, es wäre schlicht
               nichts passiert.

               Ersetzt durch eine Erkennung am DOM: teeinblue ist genau
               dann aktiv, wenn es .tee-gallery-content UND
               #tee-artwork-form eingehängt hat. Das ist unabhängig von
               Theme-Variablen und von SKU-Konventionen — wenn teeinblue
               eines Tages andere SKUs bekommt, muss hier nichts
               nachgezogen werden.

               Weil teeinblue diese Knoten erst nach dem Laden per
               JavaScript einhängt, wird nicht mehr sofort abgebrochen,
               sondern gewartet (siehe warteAufTeeinblue am Dateiende).
               Auf Produkten ohne Kampagne passiert dadurch gar nichts —
               insbesondere erscheint kein toter Zoom-Knopf.

   Alles andere ist unverändert aus der Concept-Fassung übernommen.
   ----------------------------------------------------------------

   [FIX-1] "Hängen" beim Durchswipen der Bilder im Sticky-Modus:
           touch-action:pan-y auf .tee-gallery-content entfernt – das
           hat mit dem horizontalen Swipe des Sliders kollidiert.
   [FIX-2] Pfeile + Punkte für die Bildnavigation im Zoom-Modus, damit
           sichtbar ist, dass/wie viele Bilder es gibt. Erkennt das
           scrollbare Slider-Element generisch (unabhängig von
           Teeinblue-internen Klassennamen). Sitzen jetzt UNTER dem
           Bild statt darüber.
   [FIX-3] Zoom-Button ist jetzt IMMER klickbar (nicht nur wenn man
           schon weit runtergescrollt hat). Auto-Open/-Close beim
           Scrollen bleibt wie gehabt bestehen.
   [FIX-4] Der Navigations-Status (Pfeile/Punkte) lief bisher über eine
           requestAnimationFrame-Schleife, die bei jedem Frame den
           Slider-Baum abgefragt hat – das war eine der Hauptursachen
           für das Ruckeln/Hängen, besonders gegen Ende der Bilderliste
           (wo oft noch nachgeladen wird). Jetzt rein event-basiert:
           ein passiver scroll-Listener direkt am Slider-Element, der
           nur bei tatsächlicher Bewegung minimal etwas tut.
   [FIX-5] Der Multi-Touch-Blocker (zum Verhindern von Pinch-Zoom auf
           der Seite) lief bisher dauerhaft als nicht-passiver
           touchmove-Listener über die ganze Vorschau – das bremst
           JEDEN Swipe, weil der Browser erst auf JS warten muss,
           bevor er scrollen darf. Er wird jetzt nur noch für die
           Dauer einer tatsächlichen Mehrfinger-Geste aktiviert.

   ----------------------------------------------------------------
   [NEU-A] Zoombereich jetzt 50–300 % statt 100–200 %. Neun Stufen,
           Start weiterhin bei 100 % (Index 2). Der Speicherschlüssel
           ist auf v2 gezogen, damit niemand mit einem gemerkten Index
           aus der alten Fünferliste auf einer falschen Stufe landet.
   [NEU-B] Verrutschen nach unten rechts beim Kneifzoom behoben.
           Fest positionierte Elemente hängen am ungezoomten Layout;
           zoomt der Kunde mit zwei Fingern, verschiebt der Browser nur
           den sichtbaren Ausschnitt und die Leiste wandert scheinbar
           aus dem Bild. installViewportSync() steuert über die
           visualViewport-Schnittstelle dagegen.
   ----------------------------------------------------------------

   [BEIBEHALTEN] Zentrierung/Scale/Pan-Logik unverändert.
   ========================================= */

document.addEventListener("DOMContentLoaded", () => {
  // [HORIZON-1] Concept: ".product__gallery" — Horizon rendert <media-gallery>.
  const galleryWrapperSelector = "media-gallery";

  // [HORIZON-4] Auslöser: Unterkante der Galerie statt Oberkante.
  //
  // Vorher wurde die OBERKANTE gegen ein Vielfaches der Bildschirmhöhe
  // geprüft (rect.top < -innerHeight * 1.5). Das hat viel zu spät
  // geschaltet: Die Galerie musste anderthalb Bildschirme weit oben raus
  // sein, obwohl sie schon lange nicht mehr zu sehen war.
  //
  // Richtig ist die UNTERKANTE. Nachgemessen: .tee-thumbnails liegt
  // innerhalb von <media-gallery>, und die Galerie endet exakt mit den
  // Miniaturen. rect.bottom ist damit genau der Punkt "Bild und
  // Miniaturen sind oben aus dem Bild".
  //
  // Beide Werte in Pixeln, nicht mehr in Bildschirmhöhen — es geht um
  // eine Kante, nicht um eine Scrollstrecke.

  // Öffnen, sobald die Unterkante diesen Tick über den oberen Rand
  // hinaus ist. Klein halten: der Kunde soll die Vorschau bekommen,
  // sobald die Galerie weg ist, nicht erst deutlich später.
  const OPEN_TICK_PX = 24;

  // Schließen erst, wenn wieder ein sichtbares Stück Galerie im Bild
  // steht. Der Abstand zwischen den beiden Werten (24 + 90 = 114 px)
  // ist die Hysterese: Ohne diesen Abstand würde die Vorschau genau an
  // der Umschaltkante bei jeder kleinen Bewegung auf- und zuklappen.
  const CLOSE_SHOW_PX = 90;

  const PRODUCT_HANDLE =
    window.location.pathname.split("/products/")[1]?.split("?")[0]?.split("/")[0] || "unknown";

  // [NEU-A] v2, weil sich die Stufenliste geändert hat
  const SCALE_KEY = "hgde_hallo_sticky_preview_scale_step_v2";
  const PAN_KEY = "hgde_hallo_sticky_preview_pan_y_v1";

  // Mobile portrait only
  const w = window.innerWidth;
  const h = window.innerHeight;
  const isMobilePortrait = h / w > 1.5 && w < 768;
  if (!isMobilePortrait) return;

  const $gallery = document.querySelector(galleryWrapperSelector);
  if (!$gallery) return;

  // [HORIZON-2] Die SKU-Prüfung über window.json_product stand frueher hier. Sie ist
  // ersatzlos entfallen; an ihre Stelle tritt warteAufTeeinblue() ganz unten.

  // ===== CONFIG =====
  // [NEU-A] 50 % bis 300 %. Index 2 ist 100 % und damit der Start.
  const SCALE_STEPS = [0.5, 0.75, 1.0, 1.25, 1.5, 2.0, 2.5, 3.0];
  const DEFAULT_STEP_INDEX = 2;

  // [NEU] Größe der Sticky-Vorschau in % der Bildschirmbreite.
  // Das Bild ist 1:1 → dieser Wert bestimmt zugleich die Höhe der Leiste.
  // Je kleiner, desto mehr Platz bleibt unten fürs Personalisieren.
  // 100 = wie bisher (volle Breite), 70 = ca. ein Drittel weniger Höhe.
  const STICKY_SIZE_PCT = 70;

  const PANEL_LEFT_PX = 10;

  // [FIX-7] Gesamt-Footprint (Bild + Nav-Streifen) bleibt bei
  // STICKY_SIZE_PCT wie ursprünglich. NAV_BAR_VW wird davon abgezogen
  // und treibt sowohl die Boxhöhe ALS AUCH die Bild-Skalierung
  // gemeinsam an (beides muss zusammenhängen, sonst wird das Bild
  // unten abgeschnitten – genau das war der Bug in der letzten
  // Version). Beide Werte in vw, damit sie sich sauber in CSS
  // verrechnen lassen (px lässt sich nicht mit vw kombinieren, ohne
  // dass Bild- und Boxgröße auseinanderlaufen).
  const NAV_BAR_VW = 12;

  // [NEU-C] Etwas mehr Bild. In vw, damit es sich mit den übrigen
  // Größen verrechnen lässt — 2.7vw sind auf einem 375er Bildschirm
  // rund 10 px. Die Rahmenhöhe wächst automatisch mit, weil sie aus
  // derselben Größe abgeleitet wird.
  const IMAGE_EXTRA_VW = 2.7;

  const IMAGE_SIZE_PCT = STICKY_SIZE_PCT - NAV_BAR_VW + IMAGE_EXTRA_VW;

  // [NEU-C] Die Bedienleiste sitzt links und verdeckt dort Platz, den
  // das Bild nicht nutzen kann. Rechts bleibt derselbe Platz frei.
  // Wir verschieben die Bildmitte um die halbe Bedienbreite nach rechts,
  // dann steht das Bild optisch mittig im tatsächlich freien Bereich.
  // Bewusst vor scale() im Transform, damit die Verschiebung in echten
  // Pixeln wirkt und nicht mitskaliert wird.
  const CONTROLS_WIDTH_PX = PANEL_LEFT_PX + 32;
  const IMAGE_OFFSET_X_PX = Math.round(CONTROLS_WIDTH_PX / 2);

  const PAN_STEP_PX = 24;
  const PAN_MAX_ABS_PX = 260;

  // [NEU-D] Schmaler weißer Streifen über dem Bild. Der Rahmen ist
  // border-box und rechnet die Höhe inklusive Innenabstand, das Bild
  // behält also seine Größe und rückt nur nach unten. Bedienung, X und
  // der Hinweisstreifen darunter wandern um denselben Betrag mit,
  // damit nichts überlappt.
  const PADDING_TOP = 3;
  const PADDING_BOTTOM = 0;

  const REMEASURE_THRESHOLD_PX = 10;

  // ===== STATE =====
  let isStickyOpen = false;
  // Suppress-Flag: wenn User manuell mit X geschlossen hat ODER
  // Auto-Close ausgelöst wurde, blockieren wir Auto-Open so lange, bis
  // die Galerie wieder im Blick ist (Unterkante > CLOSE_SHOW_PX).
  let suppressAutoOpen = false;

  // [FIX-10] Wird true, sobald die Galerie während der aktuellen
  // Sticky-Sitzung tatsächlich weit genug aus dem Blick gescrollt wurde.
  // Erst DANN darf Auto-Close greifen. Ohne dieses Flag hat die
  // Auto-Close-Prüfung sofort angeschlagen, wenn man ganz oben manuell
  // auf Zoom geklickt hat – die Galerie war ja noch sichtbar, das
  // erfüllte die "wieder im Blick" Bedingung augenblicklich. Der Kunde
  // soll die Vorschau aber jederzeit manuell öffnen können, unabhängig
  // von der Scrollposition, und sie soll dann auch offen bleiben, bis
  // er wirklich wegscrollt.
  let hasLeftCloseZone = false;

  let portal = null;
  let hint = null;
  let hintTimer = null;
  let stickyBtn = null;
  let closeBtn = null;

  let scalePanel = null;
  let minusBtn = null;
  let plusBtn = null;
  let stepLabel = null;

  let upBtn = null;
  let downBtn = null;

  // [FIX-2 / FIX-4] Navigations-Leiste (Pfeile + Punkte) – event-basiert,
  // keine Dauerschleife mehr.
  // [FIX-8] Statischer Hinweistext statt Pfeile/Punkte – braucht keine
  // Erkennung des Slider-Mechanismus mehr, funktioniert also garantiert.
  let navWrap = null;

  let movedNode = null;
  let originalParent = null;
  let originalNext = null;

  let placeholder = null;
  let wrapper = null;
  let lastMeasuredH = 0;

  // [NEU] gesicherte Scrollpositionen des Sliders für das Umhängen
  let pendingSnap = [];

  const qs = (sel, root = document) => root.querySelector(sel);

  const getGalleryContent = () =>
    qs(`${galleryWrapperSelector} .tee-gallery-content`) || qs(".tee-gallery-content");

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  const loadStepIndex = () => {
    const raw = sessionStorage.getItem(SCALE_KEY);
    const n = raw == null ? DEFAULT_STEP_INDEX : parseInt(raw, 10);
    if (Number.isNaN(n)) return DEFAULT_STEP_INDEX;
    return clamp(n, 0, SCALE_STEPS.length - 1);
  };

  let scaleStepIndex = loadStepIndex();

  const setScaleVar = (val) => {
    document.documentElement.style.setProperty("--hgdeStickyScale", String(val));
  };

  const loadPanY = () => {
    const raw = sessionStorage.getItem(PAN_KEY);
    const n = raw == null ? 0 : parseInt(raw, 10);
    if (Number.isNaN(n)) return 0;
    return clamp(n, -PAN_MAX_ABS_PX, PAN_MAX_ABS_PX);
  };

  let panY = loadPanY();

  const setPanVar = (val) => {
    document.documentElement.style.setProperty("--hgdeStickyPanY", `${val}px`);
  };

  const updateScaleUi = () => {
    const val = SCALE_STEPS[scaleStepIndex];
    if (stepLabel) stepLabel.textContent = `${Math.round(val * 100)}%`;
    if (minusBtn) minusBtn.style.opacity = scaleStepIndex === 0 ? "0.35" : "1";
    if (plusBtn) plusBtn.style.opacity = scaleStepIndex === SCALE_STEPS.length - 1 ? "0.35" : "1";
  };

  // [GEÄNDERT] kein await/kein Neumessen des Platzhalters mehr –
  // Zoom verändert nur noch den Transform, nie das Seitenlayout.
  const applyScaleStep = (delta) => {
    const next = clamp(scaleStepIndex + delta, 0, SCALE_STEPS.length - 1);
    if (next === scaleStepIndex) return;

    scaleStepIndex = next;
    sessionStorage.setItem(SCALE_KEY, String(scaleStepIndex));

    setScaleVar(SCALE_STEPS[scaleStepIndex]);
    updateScaleUi();

    // Pan nachziehen, falls der neue Zoom weniger Spielraum lässt
    const maxAbs = clampPanByViewport();
    const clamped = clamp(panY, -maxAbs, maxAbs);
    if (clamped !== panY) {
      panY = clamped;
      sessionStorage.setItem(PAN_KEY, String(panY));
      setPanVar(panY);
    }

    updatePanUi();
  };

  // [GEÄNDERT] Der Rahmen hat jetzt eine feste Höhe und das Bild passt
  // bei 100% exakt hinein. Überstand entsteht nur durch Zoom und liegt
  // wegen transform-origin:top unten → rein rechnerisch, keine Messung.
  const clampPanByViewport = () => {
    const box = movedNode || null;
    if (!box) return PAN_MAX_ABS_PX;

    const frameH = box.getBoundingClientRect().height || 0;
    if (!frameH) return PAN_MAX_ABS_PX;

    const overflow = frameH * (SCALE_STEPS[scaleStepIndex] - 1);
    return clamp(Math.round(overflow), 0, PAN_MAX_ABS_PX);
  };

  // [NEU] Bei 100% gibt es nichts zu verschieben → Pfeile abblenden,
  // damit keine toten Buttons dastehen.
  const updatePanUi = () => {
    const maxAbs = clampPanByViewport();
    if (upBtn) upBtn.style.opacity = maxAbs === 0 || panY <= -maxAbs ? "0.35" : "1";
    if (downBtn) downBtn.style.opacity = maxAbs === 0 || panY >= maxAbs ? "0.35" : "1";
  };

  // [GEÄNDERT] kein await/kein Neumessen des Platzhalters mehr
  const applyPan = (deltaPx) => {
    const maxAbs = clampPanByViewport();
    const next = clamp(panY + deltaPx, -maxAbs, maxAbs);
    if (next === panY) return;

    panY = next;
    sessionStorage.setItem(PAN_KEY, String(panY));
    setPanVar(panY);

    updatePanUi();
  };

  setScaleVar(SCALE_STEPS[scaleStepIndex]);
  setPanVar(panY);

  const zoomBg = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M114.5,79.1C95,79.1,79.1,95,79.1,114.5v283c0,19.5,15.8,35.4,35.4,35.4h283c19.5,0,35.4-15.8,35.4-35.4v-283c0-19.5-15.8-35.4-35.4-35.4H114.5z M114.5,409.3c-6.5,0-11.8-5.3-11.8-11.8V308l94.3-94.3l195.6,195.6H114.5z M409.3,392.7L331.6,315l30.5-30.5l47.2,47.2V392.7z M409.3,114.5v183.8l-38.8-38.9c-4.6-4.6-12.1-4.7-16.7-0.1L315,298.3L205.4,188.7c-4.6-4.6-12.1-4.7-16.7-0.1l-86,86.1V114.5c0-6.5,5.3-11.8,11.8-11.8h283c6.5,0,11.8,5.3,11.8,11.8z"/><path d="M326.7,138.1c-26,0-47.2,21.1-47.2,47.2s21.1,47.2,47.2,47.2s47.2-21.1,47.2-47.2S352.8,138.1,326.7,138.1z M326.7,208.8c-13,0-23.6-10.6-23.6-23.6s10.6-23.6,23.6-23.6s23.6,10.6,23.6,23.6-10.6,23.6-23.6,23.6z"/></svg>')`;

  const closeSvg = `<svg viewBox="0 0 329 329" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M194.8 164.77l128.21-128.21c8.34-8.34 8.34-21.82 0-30.16-8.34-8.34-21.82-8.34-30.16 0L164.64 134.6 36.43 6.39c-8.34-8.34-21.82-8.34-30.16 0-8.34 8.34-8.34 21.82 0 30.16l128.21 128.21L6.27 292.98c-8.34 8.34-8.34 21.82 0 30.16 4.16 4.16 9.62 6.25 15.08 6.25s10.92-2.09 15.08-6.25l128.21-128.21 128.21 128.21c4.16 4.16 9.62 6.25 15.08 6.25s10.92-2.09 15.08-6.25c8.34-8.34 8.34-21.82 0-30.16z"/></svg>`;

  const injectStyles = () => {
    const style = document.createElement("style");
    style.textContent = `
      :root{
        --hgdeStickyScale: ${SCALE_STEPS[scaleStepIndex]};
        --hgdeStickyPanY: ${panY}px;
        /* [NEU-C] Seitlicher Versatz, damit das Bild neben der
           Bedienung mittig steht statt im Gesamtfenster. */
        --hgdeStickyOffsetX: ${IMAGE_OFFSET_X_PX}px;
        /* [NEU] Kantenlänge der quadratischen Vorschau */
        --hgdeStickySize: ${IMAGE_SIZE_PCT}vw;
        /* [FIX-6/7] Feste Höhe für die Pfeil/Punkte-Leiste, in vw statt
           px, damit sie sich mit --hgdeStickySize zu genau
           STICKY_SIZE_PCT addiert (siehe unten). */
        --hgdeStickyNavH: ${NAV_BAR_VW}vw;
        /* [NEU] Grundskalierung. Das Layout bleibt bei voller Breite
           (sonst reißt es den Slider auseinander), verkleinert wird
           ausschließlich optisch über den Transform. */
        --hgdeStickyFit: ${IMAGE_SIZE_PCT / 100};
      }

      /* [HORIZON-6] Die Vorschau darf die Seite nie breiter machen als das
         Fenster.

         Beobachtet am Geraet (01.09.2026): Auf teeinblue-Produkten stand
         rechts ein weisser Streifen, auf Produkten ohne Konfigurator nicht.
         Der Inhalt war dabei nicht zu breit, sondern SCHMALER als der
         Bildschirm — fest positionierte Leisten reichten weiter nach rechts
         als der Seiteninhalt. Das ist das Bild einer herausgezoomten Seite:
         Etwas macht das Dokument breiter als das Fenster, Chrome zoomt heraus,
         um alles zu zeigen, und rechts bleibt Hintergrund stehen.

         Welches Element den Ueberstand erzeugt, liess sich nicht einkreisen:
         In der Emulation bei 375 px ist scrollWidth in jedem Zustand exakt
         gleich der Fensterbreite — geschlossen, geoeffnet, wieder geschlossen.
         Der Fehler tritt nur auf echten Geraeten auf.

         overflow-x: clip am <html> beendet das unabhaengig von der Ursache.
         Bewusst clip und NICHT hidden: hidden macht das Element zu einem
         Scroll-Container und bricht damit jedes position: sticky darin — in
         Horizon unter anderem den mitlaufenden Kopfbereich. clip unterbindet
         nur das seitliche Scrollen und laesst sticky in Ruhe. Die
         Kategorie-Slider haben ihren eigenen Scrollbereich und sind nicht
         betroffen.

         Die Regel steht bewusst HIER und nicht im Theme-CSS: Sie wird nur
         eingefuegt, wenn dieses Skript ueberhaupt anlaeuft — also auf
         teeinblue-Produkten im Hochformat unter 768 px. Genau dort, wo der
         Streifen auftritt, und nirgends sonst. */
      html{
        overflow-x: clip;
      }

      #hgde-sticky-portal{
        position: fixed;
        /* [HORIZON-3] Hier stand width: 100vw. Das war die Ursache fuer den
           schmalen weissen Streifen rechts auf dem Handy: 100vw ist die
           Breite des Layout-Viewports OHNE Ruecksicht darauf, wie breit der
           Inhalt tatsaechlich sein darf. Sobald der Browser eine senkrechte
           Bildlaufleiste einrechnet oder die Seite ohnehin schon minimal
           breiter ist als der sichtbare Bereich, ragt der Kasten nach rechts
           hinaus. Weil er fest positioniert ist, wackelt nichts — die Seite
           steht nur dauerhaft ein Stueck nach links versetzt, mit Weissraum
           an der rechten Kante.

           inset: 0 setzt links UND rechts auf 0. Damit ist der Kasten immer
           exakt so breit wie der sichtbare Bereich und kann per Definition
           nicht darueber hinausragen. Keine Breitenangabe ergaenzen. */
        inset: 0;
        height: 0;
        z-index: 2147483647;
        pointer-events: none;
      }

      .hgde-sticky-placeholder{
        width: 100%;
        height: 0px;
      }

      body.gallery--sticky #hgde-sticky-portal .tee-gallery-content{
        pointer-events: auto;
        position: fixed;
        top: env(safe-area-inset-top, 0px);
        left: 0;
        right: 0;
        width: 100%;
        /* [NEU] feste Höhe statt Inhaltshöhe – dadurch steht der Rahmen
           sofort, unabhängig davon ob das Bild schon geladen ist.
           !important, weil der Slider dem Container eine Höhe per
           Inline-Style verpasst; ohne das bleibt die weiße Fläche hoch,
           obwohl das Bild schon verkleinert ist.
           [FIX-7] --hgdeStickySize ist jetzt bereits die um den
           Nav-Streifen reduzierte Bildgröße (siehe --hgdeStickyFit
           weiter oben, beide hängen zusammen) – kein zusätzlicher Abzug
           mehr nötig, dadurch kein Abschneiden des Bildes mehr. */
        height: calc(var(--hgdeStickySize) + ${PADDING_TOP}px + ${PADDING_BOTTOM}px) !important;
        min-height: 0 !important;
        max-height: calc(var(--hgdeStickySize) + ${PADDING_TOP}px + ${PADDING_BOTTOM}px) !important;
        box-sizing: border-box;
        padding: ${PADDING_TOP}px 0 ${PADDING_BOTTOM}px 0;
        background: #fff;
        box-shadow: 0 10px 35px rgba(0,0,0,.25);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;
        transform: translateZ(0);
      }

      body.gallery--sticky #hgde-sticky-portal .hgde-sticky-scale{
        display: block;
        /* Layoutbreite bleibt voll – der Slider rechnet intern mit
           Pixelbreiten, ein schmalerer Kasten würde ihn nur nach rechts
           schieben statt ihn zu verkleinern. */
        width: 100%;
        /* [GEÄNDERT] Verkleinert wird rein optisch: Grundskalierung mal
           Zoomstufe. Bei 1:1 wird aus 100vw Höhe damit exakt
           STICKY_SIZE_PCT vw – genau die Höhe des Rahmens. */
        transform: translateX(var(--hgdeStickyOffsetX))
                   translateY(var(--hgdeStickyPanY))
                   scale(calc(var(--hgdeStickyFit) * var(--hgdeStickyScale)));
        transform-origin: top center;
        will-change: transform;
      }

      body.gallery--sticky #hgde-sticky-portal .tee-thumbnails,
      body.gallery--sticky #hgde-sticky-portal .tee-slider__dots{
        display: none !important;
      }

      /* [FIX-1] touch-action:pan-y entfernt – das hat mit dem
         horizontalen Swipe des Sliders kollidiert und zum "Hängen"
         beim Durchblättern der Bilder geführt. overscroll-behavior
         bleibt (verhindert nur Pull-to-refresh der Seite dahinter). */
      body.gallery--sticky #hgde-sticky-portal .tee-gallery-content{
        overscroll-behavior: contain;
      }

      .sticky-gallery-button{
        background-color: #fff;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 20px 20px;
        border-radius: 50%;
        box-shadow: 0 4px 14px rgba(0,0,0,.2);
        /* [FIX-3] Standardmäßig sichtbar – der Button soll unabhängig
           von der Scrollposition immer klickbar sein. */
        display: block;
        height: 44px;
        width: 44px;
        position: fixed;
        right: 16px;
        top: calc(env(safe-area-inset-top, 0px) + 96px);
        z-index: 2147483647;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }

      body.gallery--sticky .sticky-gallery-button{
        display: none !important;
      }

      .sticky-gallery-button::after{
        content: "Zoom";
        position: absolute;
        top: 48px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 11px;
        line-height: 1;
        color: rgba(0,0,0,.55);
        white-space: nowrap;
        pointer-events: none;
      }

      .hgde-sticky-close{
        position: fixed;
        right: 14px;
        top: calc(env(safe-area-inset-top, 0px) + ${14 + PADDING_TOP}px);
        width: 44px;
        height: 44px;
        border-radius: 999px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 6px 18px rgba(0,0,0,.18);
        display: none;
        align-items: center;
        justify-content: center;
        pointer-events: auto;
        z-index: 2147483647;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        user-select: none;
      }

      body.gallery--sticky .hgde-sticky-close{
        display: flex;
      }

      .hgde-sticky-close svg{
        width: 18px;
        height: 18px;
        opacity: .65;
      }

      .hgde-sticky-hint{
        position: fixed;
        right: 16px;
        top: calc(env(safe-area-inset-top, 0px) + 148px);
        z-index: 2147483647;
        background: rgba(0,0,0,.78);
        color: #fff;
        padding: 8px 10px;
        border-radius: 999px;
        font-size: 12px;
        line-height: 1;
        display: none;
        max-width: 70vw;
        pointer-events: none;
      }

      .hgde-sticky-hint.show{
        display: inline-flex;
      }

      .hgde-sticky-scale-panel{
        position: fixed;
        left: ${PANEL_LEFT_PX}px;
        top: calc(env(safe-area-inset-top, 0px) + ${12 + PADDING_TOP}px);
        z-index: 2147483647;
        display: none;
        flex-direction: column;
        gap: 6px;
        align-items: center;
        pointer-events: auto;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
      }

      body.gallery--sticky .hgde-sticky-scale-panel{
        display: flex;
      }

      .hgde-sticky-scale-btn{
        width: 32px;
        height: 32px;
        border-radius: 999px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 4px 12px rgba(0,0,0,.18);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 1;
        color: rgba(0,0,0,.72);
        cursor: pointer;
      }

      .hgde-sticky-scale-label{
        height: 26px;
        padding: 0 8px;
        border-radius: 999px;
        background: rgba(255,255,255,.92);
        box-shadow: 0 4px 12px rgba(0,0,0,.18);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        color: rgba(0,0,0,.6);
        min-width: 52px;
      }

      /* [FIX-9] Statischer Hinweistext, jetzt mit eigenem weißen
         Hintergrund direkt an den Bildkasten anschließend – dadurch
         wirkt es wie EINE durchgehende weiße Fläche statt Text auf dem
         Seitenhintergrund. Gesamthöhe (Bild + Textstreifen) bleibt
         weiterhin exakt STICKY_SIZE_PCT. */
      .hgde-sticky-nav{
        position: fixed;
        left: 0;
        right: 0;
        top: calc(env(safe-area-inset-top, 0px) + ${PADDING_TOP}px + var(--hgdeStickySize));
        height: var(--hgdeStickyNavH);
        z-index: 2147483647;
        display: none;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        color: rgba(0,0,0,.55);
        pointer-events: none;
        text-align: center;
        padding: 0 8px;
        background: #fff;
        box-shadow: 0 10px 20px rgba(0,0,0,.12);
        box-sizing: border-box;
      }

      body.gallery--sticky .hgde-sticky-nav{
        display: flex;
      }
    `;
    document.head.appendChild(style);
  };

  const showHint = (ms = 2200) => {
    if (!hint) return;
    hint.classList.add("show");
    if (hintTimer) clearTimeout(hintTimer);
    hintTimer = setTimeout(() => {
      hint.classList.remove("show");
      hintTimer = null;
    }, ms);
  };

  const ensureDom = () => {
    if (!portal) {
      portal = document.createElement("div");
      portal.id = "hgde-sticky-portal";
      document.body.appendChild(portal);

      // [FIX-5] Statt dauerhaft einen non-passive touchmove-Listener zu
      // halten (bremst JEDEN Swipe, weil der Browser auf JS warten muss),
      // hängen wir den preventDefault-Listener nur für die Dauer einer
      // tatsächlichen Mehrfinger-Geste ein und entfernen ihn danach sofort
      // wieder. Normale Ein-Finger-Swipes laufen dadurch ungebremst.
      let multiTouchCleanup = null;

      const startMultiTouchGuard = () => {
        if (multiTouchCleanup) return;

        const preventPinch = (e) => {
          if (e.touches && e.touches.length > 1) e.preventDefault();
        };

        const cleanup = () => {
          portal.removeEventListener("touchmove", preventPinch, { passive: false });
          portal.removeEventListener("touchend", cleanup);
          portal.removeEventListener("touchcancel", cleanup);
          multiTouchCleanup = null;
        };

        portal.addEventListener("touchmove", preventPinch, { passive: false });
        portal.addEventListener("touchend", cleanup);
        portal.addEventListener("touchcancel", cleanup);
        multiTouchCleanup = cleanup;
      };

      portal.addEventListener(
        "touchstart",
        (e) => {
          if (!document.body.classList.contains("gallery--sticky")) return;
          if (!portal.contains(e.target)) return;
          if (e.touches && e.touches.length > 1) startMultiTouchGuard();
        },
        { passive: true }
      );
    }

    if (!hint) {
      hint = document.createElement("div");
      hint.className = "hgde-sticky-hint";
      hint.textContent = 'Klicke “Zoom” für die Live-Vorschau.';
      document.body.appendChild(hint);
    }

    if (!stickyBtn) {
      stickyBtn = document.createElement("div");
      stickyBtn.className = "sticky-gallery-button";
      stickyBtn.style.backgroundImage = zoomBg;

      stickyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Manueller Open hebt die Auto-Open-Sperre auf
        suppressAutoOpen = false;
        openSticky();
      });

      document.body.appendChild(stickyBtn);
    }

    if (!closeBtn) {
      closeBtn = document.createElement("div");
      closeBtn.className = "hgde-sticky-close";
      closeBtn.setAttribute("role", "button");
      closeBtn.setAttribute("aria-label", "Close preview");
      closeBtn.innerHTML = closeSvg;

      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        // User schließt manuell → kein Auto-Open mehr, bis hochgescrollt wurde
        suppressAutoOpen = true;
        closeSticky();
        showHint();
      });

      document.body.appendChild(closeBtn);
    }

    if (!scalePanel) {
      scalePanel = document.createElement("div");
      scalePanel.className = "hgde-sticky-scale-panel";

      plusBtn = document.createElement("div");
      plusBtn.className = "hgde-sticky-scale-btn";
      plusBtn.setAttribute("role", "button");
      plusBtn.setAttribute("aria-label", "Zoom in");
      plusBtn.textContent = "+";
      plusBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyScaleStep(+1);
      });

      stepLabel = document.createElement("div");
      stepLabel.className = "hgde-sticky-scale-label";

      minusBtn = document.createElement("div");
      minusBtn.className = "hgde-sticky-scale-btn";
      minusBtn.setAttribute("role", "button");
      minusBtn.setAttribute("aria-label", "Zoom out");
      minusBtn.textContent = "−";
      minusBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyScaleStep(-1);
      });

      upBtn = document.createElement("div");
      upBtn.className = "hgde-sticky-scale-btn";
      upBtn.setAttribute("role", "button");
      upBtn.setAttribute("aria-label", "Move up");
      upBtn.textContent = "↑";
      upBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyPan(-PAN_STEP_PX);
      });

      downBtn = document.createElement("div");
      downBtn.className = "hgde-sticky-scale-btn";
      downBtn.setAttribute("role", "button");
      downBtn.setAttribute("aria-label", "Move down");
      downBtn.textContent = "↓";
      downBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        applyPan(+PAN_STEP_PX);
      });

      scalePanel.appendChild(plusBtn);
      scalePanel.appendChild(stepLabel);
      scalePanel.appendChild(minusBtn);
      scalePanel.appendChild(upBtn);
      scalePanel.appendChild(downBtn);

      document.body.appendChild(scalePanel);
      updateScaleUi();
    }

    // [FIX-8] Statischer Hinweistext statt Pfeile/Punkte
    if (!navWrap) {
      navWrap = document.createElement("div");
      navWrap.className = "hgde-sticky-nav";
      navWrap.textContent = "Wische zum nächsten Bild";
      document.body.appendChild(navWrap);
    }
  };

  // ===== [FIX-8] Kein Slider-Detection-Code mehr nötig – der Hinweis
  // ist statisch und braucht keine Kenntnis des Slider-Mechanismus. =====

  // [GEÄNDERT] Der Platzhalter bekommt seine Höhe jetzt SYNCHRON und aus
  // der Breite (Bild ist 1:1). Vorher: zwei requestAnimationFrame später
  // und aus der gemessenen Höhe – in der Zwischenzeit war die Galerie
  // schon aus dem Fluss, der Platzhalter aber noch 0px hoch. Genau das
  // war der Sprung.
  const ensurePlaceholder = (node) => {
    if (placeholder) return;
    if (!originalParent) return;

    const rect = node.getBoundingClientRect();
    const flowH = Math.round(rect.width > 0 ? rect.width : rect.height);

    placeholder = document.createElement("div");
    placeholder.className = "hgde-sticky-placeholder";
    placeholder.style.height = `${flowH}px`;

    lastMeasuredH = flowH;

    originalParent.insertBefore(placeholder, originalNext);
  };

  const removePlaceholder = () => {
    if (!placeholder) return;
    placeholder.remove();
    placeholder = null;
    lastMeasuredH = 0;
  };

  const wrapForScaling = () => {
    if (!movedNode) return;

    wrapper = movedNode.querySelector(".hgde-sticky-scale");
    if (wrapper) return;

    wrapper = document.createElement("div");
    wrapper.className = "hgde-sticky-scale";

    while (movedNode.firstChild) {
      wrapper.appendChild(movedNode.firstChild);
    }

    movedNode.appendChild(wrapper);
  };

  // [NEU] Slider verlieren beim Umhängen ihre interne Scrollposition –
  // der Slide steht dann leicht daneben, bis der Slider irgendwann von
  // selbst nachrechnet (das war der Ruck nach ein paar Sekunden).
  // Wir sichern die Positionen und setzen sie sofort wieder.
  const snapshotScrollPositions = (node) => {
    const snap = [];

    node.querySelectorAll("*").forEach((el) => {
      const hasX = el.scrollWidth > el.clientWidth + 1;
      const hasY = el.scrollHeight > el.clientHeight + 1;
      if (!hasX && !hasY) return;
      if (el.scrollLeft === 0 && el.scrollTop === 0) return;

      snap.push({ el, left: el.scrollLeft, top: el.scrollTop });
    });

    return snap;
  };

  const restoreScrollPositions = (snap) => {
    snap.forEach(({ el, left, top }) => {
      if (el.scrollLeft !== left) el.scrollLeft = left;
      if (el.scrollTop !== top) el.scrollTop = top;
    });
  };

  // [NEU] Der Slider richtet sich erst aus, wenn ein scroll- oder
  // resize-Event kommt – deshalb sprang das Bild erst zurecht, sobald
  // der Kunde gescrollt hat. Wir feuern beides sofort selbst.
  const nudgeSliderLayout = (snap) => {
    restoreScrollPositions(snap);

    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("scroll"));

    requestAnimationFrame(() => {
      restoreScrollPositions(snap);
      window.dispatchEvent(new Event("scroll"));
    });
  };

  const mountToPortal = () => {
    const node = getGalleryContent();
    if (!node) return false;

    if (node.parentElement === portal) {
      movedNode = node;
      return true;
    }

    originalParent = node.parentNode;
    originalNext = node.nextSibling;

    // [GEÄNDERT] Platzhalter steht, BEVOR der Knoten den Fluss verlässt.
    // Beides im selben Frame → die Seite bewegt sich nicht.
    ensurePlaceholder(node);

    pendingSnap = snapshotScrollPositions(node);

    portal.appendChild(node);
    movedNode = node;

    // Der Anstoß passiert bewusst erst in openSticky(), NACHDEM
    // isStickyOpen gesetzt ist – sonst löst das resize-Event unseren
    // eigenen Scroll-Handler aus und openSticky() liefe erneut an.
    return true;
  };

  const restoreFromPortal = () => {
    if (!movedNode || !originalParent) return;

    // [GEÄNDERT] kein unwrapScaling() mehr. Der Wrapper bleibt bestehen,
    // dadurch werden die Bildknoten beim nächsten Öffnen NICHT wieder
    // umgehängt – das war die Ursache für das sichtbare Neuladen.
    // [NEU] auch beim Zurücklegen die Slider-Position sichern.
    // Hier bewusst OHNE scroll-Event: der Handler würde bei
    // isStickyOpen === false sofort wieder öffnen wollen.
    const snap = snapshotScrollPositions(movedNode);

    // [NEU-B] Reste des Kneifzoom-Ausgleichs entfernen, bevor der Knoten
    // zurück in den Seitenfluss wandert – sonst behielte die Galerie dort
    // die Verschiebung und Breite aus dem gezoomten Zustand.
    movedNode.style.transform = "";
    movedNode.style.transformOrigin = "";
    movedNode.style.width = "";

    if (placeholder && placeholder.parentNode === originalParent) {
      originalParent.insertBefore(movedNode, placeholder);
    } else {
      originalParent.insertBefore(movedNode, originalNext);
    }

    restoreScrollPositions(snap);

    removePlaceholder();

    movedNode = null;
    originalParent = null;
    originalNext = null;
  };

  const keepMountedIfRerendered = () => {
    if (!isStickyOpen) return;

    const node = getGalleryContent();
    if (!node) return;

    if (node.parentElement !== portal) {
      portal.appendChild(node);
      movedNode = node;
    } else {
      movedNode = node;
    }

    wrapForScaling();
  };

  const openSticky = () => {
    if (isStickyOpen) return;

    ensureDom();

    // [GEÄNDERT] Klasse VOR dem Umhängen: der Rahmen steht damit schon
    // an der richtigen Stelle, wenn das Bild hineinkommt.
    document.body.classList.add("gallery--sticky");

    if (!mountToPortal()) {
      document.body.classList.remove("gallery--sticky");
      return;
    }

    isStickyOpen = true;
    hasLeftCloseZone = false;

    setScaleVar(SCALE_STEPS[scaleStepIndex]);
    setPanVar(panY);

    wrapForScaling();
    updateScaleUi();
    updatePanUi();

    // [NEU] Erst jetzt anstoßen: isStickyOpen steht, das ausgelöste
    // scroll-Event kann openSticky() also nicht erneut starten.
    nudgeSliderLayout(pendingSnap);
    pendingSnap = [];
  };

  const closeSticky = () => {
    if (!isStickyOpen) return;

    isStickyOpen = false;

    document.body.classList.remove("gallery--sticky");

    // [GEÄNDERT] war setTimeout(…, 80) – die 80ms waren ein zweiter
    // sichtbarer Versatz beim Schließen.
    restoreFromPortal();
  };

  const autoToggleOnScroll = () => {
    // [HORIZON-4] rect.bottom = Unterkante der Galerie einschliesslich
    // Miniaturen. Beim Runterscrollen wird dieser Wert kleiner.
    const unten = $gallery.getBoundingClientRect().bottom;

    if (isStickyOpen) {
      // [FIX-10] Erst merken, dass die Galerie wirklich aus dem Bild war …
      if (unten < CLOSE_SHOW_PX) {
        hasLeftCloseZone = true;
      }
      // … und NUR DANN automatisch schließen, wenn man wieder hochscrollt.
      // Verhindert, dass ein manuelles Öffnen ganz oben (Galerie noch
      // sichtbar) sofort wieder zuklappt.
      if (hasLeftCloseZone && unten > CLOSE_SHOW_PX) {
        closeSticky();
      }
      return;
    }

    // Sticky ist zu und die Galerie wieder im Blick: Sperre aufheben,
    // damit ein erneutes Runterscrollen wieder öffnen darf.
    if (unten > CLOSE_SHOW_PX) {
      suppressAutoOpen = false;
      return;
    }

    // Galerie samt Miniaturen oben raus (plus Tick) und nicht gesperrt → öffnen
    if (!suppressAutoOpen && unten < -OPEN_TICK_PX) {
      openSticky();
    }
  };

  // [FIX-1] Der eigentliche Scroll-Handler bleibt inhaltlich gleich,
  // wird jetzt aber über requestAnimationFrame gedrosselt aufgerufen
  // (siehe onScroll weiter unten), statt bei jedem einzelnen
  // scroll-Event zu feuern.
  const handleScroll = () => {
    autoToggleOnScroll();

    const galleryTop = $gallery.getBoundingClientRect().top;
    const formBottom = qs("#tee-artwork-form")?.getBoundingClientRect().bottom || 999999;

    // Diese Klasse wird nicht mehr für die Sichtbarkeit des Zoom-Buttons
    // gebraucht (siehe FIX-3), bleibt aber bestehen, falls andere Styles
    // im Theme darauf aufbauen.
    if (galleryTop < -10 && formBottom > 200) {
      document.body.classList.add("gallery--sticky-ready");
    } else {
      document.body.classList.remove("gallery--sticky-ready");
    }
  };

  // [FIX-1] rAF-Drosselung: statt bei jedem scroll-Event sofort
  // getBoundingClientRect() etc. auszuführen, wird das auf einen
  // Frame pro Scroll-Burst reduziert. Spürbar ruhiger auf schwächeren
  // Mobilgeräten, besonders während gleichzeitig im Bild geswiped wird.
  let scrollScheduled = false;
  const onScroll = () => {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      scrollScheduled = false;
      handleScroll();
    });
  };

  const closeStickyAfterImageUpload = () => {
    document.addEventListener(
      "change",
      (e) => {
        const input = e.target;

        if (!input || input.tagName !== "INPUT") return;
        if (input.type !== "file") return;
        if (!input.files || input.files.length === 0) return;

        const hasImageFile = Array.from(input.files).some((file) =>
          String(file.type || "").startsWith("image/")
        );

        if (!hasImageFile) return;

        suppressAutoOpen = true;

        if (isStickyOpen) {
          closeSticky();
        }

        document.body.classList.remove("gallery--sticky-ready");
      },
      true
    );
  };

  // ============================================================
  // [NEU-B] Nachführen beim Kneifzoom
  //
  // Zoomt der Kunde die Seite mit zwei Fingern, verschiebt der Browser
  // den sichtbaren Ausschnitt. Fest positionierte Elemente bleiben aber
  // am ungezoomten Layout hängen — die Leiste rutschte dadurch scheinbar
  // nach unten rechts aus dem Bild.
  //
  // visualViewport liefert Versatz und Zoomfaktor des sichtbaren
  // Ausschnitts. Damit wird gegengesteuert: verschieben um den Versatz,
  // gegenskalieren mit 1/Zoom, damit die Leiste ihre Größe auf dem
  // Schirm behält. Rechts verankerte Knöpfe brauchen den Versatz von der
  // rechten Kante aus, sonst wandern sie aus dem Bild.
  //
  // Sobald der Zoom wieder bei 1 liegt oder die Vorschau geschlossen
  // wird, werden alle gesetzten Werte entfernt.
  // ============================================================
  const installViewportSync = () => {
    const vv = window.visualViewport;
    if (!vv) return;

    const sync = () => {
      const offen = document.body.classList.contains("gallery--sticky");
      const scale = vv.scale || 1;
      const layoutW = document.documentElement.clientWidth;
      const leftX = vv.offsetLeft;
      const rightX = vv.offsetLeft + vv.width - layoutW;
      const topY = vv.offsetTop;
      // [HORIZON-5] Nur bei echtem Kneifzoom NACH INNEN gegensteuern.
      //
      // Vorher stand hier Math.abs(scale - 1) < 0.01 — die Abweichung wurde
      // also in BEIDE Richtungen als Kneifzoom gewertet. Ist die Seite aber
      // herausgezoomt (scale < 1, etwa weil irgendetwas die Seite breiter
      // macht als den Bildschirm), dann ist vv.width GROESSER als die
      // Layoutbreite. Die Ausgleichsrechnung unten dreht sich damit um:
      // rightX wird positiv und schiebt die rechts verankerten Knoepfe aus
      // dem Bild, und movedNode bekommt eine Breite groesser als die Seite.
      // Sichtbar war das als angeschnittenes X oben rechts und als Galerie,
      // die in den weissen Streifen hineinlief und ihn dadurch festhielt.
      //
      // Herauszoomen braucht gar keinen Ausgleich: Dabei sieht der Kunde
      // ohnehin mehr als den Bildschirm, fest positionierte Leisten stehen
      // dann korrekt an den Kanten des sichtbaren Bereichs.
      const eingezoomt = scale > 1.01;
      const normal = !offen || !eingezoomt;

      if (normal) {
        if (movedNode) {
          movedNode.style.transform = offen ? "translateZ(0)" : "";
          movedNode.style.transformOrigin = "";
          movedNode.style.width = "";
        }
        [navWrap, scalePanel, closeBtn, stickyBtn, hint].forEach((el) => {
          if (!el) return;
          el.style.transform = "";
          el.style.transformOrigin = "";
        });
        return;
      }

      const inv = 1 / scale;

      if (movedNode) {
        movedNode.style.transformOrigin = "left top";
        movedNode.style.transform = `translate(${leftX}px, ${topY}px) scale(${inv})`;
        // [HORIZON-5] Nie breiter als die Seite selbst. Sonst erzeugt die
        // Vorschau genau den seitlichen Ueberstand, den sie ausgleichen soll.
        movedNode.style.width = `${Math.min(vv.width * scale, layoutW)}px`;
      }

      [navWrap, scalePanel].forEach((el) => {
        if (!el) return;
        el.style.transformOrigin = "left top";
        el.style.transform = `translate(${leftX}px, ${topY}px) scale(${inv})`;
      });

      [closeBtn, stickyBtn, hint].forEach((el) => {
        if (!el) return;
        el.style.transformOrigin = "right top";
        el.style.transform = `translate(${rightX}px, ${topY}px) scale(${inv})`;
      });
    };

    let geplant = false;
    const anstossen = () => {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(() => {
        geplant = false;
        sync();
      });
    };

    vv.addEventListener("resize", anstossen);
    vv.addEventListener("scroll", anstossen);
    anstossen();
  };

  // ===== INIT =====
  const starten = () => {
    injectStyles();
    ensureDom();
    installViewportSync();
    closeStickyAfterImageUpload();

    const mo = new MutationObserver(() => keepMountedIfRerendered());
    mo.observe($gallery, { childList: true, subtree: true });

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => onScroll(), { passive: true });

    setTimeout(() => {
      onScroll();
    }, 1600);
  };

  // ============================================================
  // [HORIZON-2] Warten, bis teeinblue da ist
  //
  // In Concept stand an dieser Stelle eine SKU-Prüfung über
  // window.json_product. Diese Variable existiert in Horizon nicht — die
  // Prüfung wäre immer false gewesen und das Skript hätte weit oben per
  // return abgebrochen, ohne Fehlermeldung.
  //
  // Stattdessen wird jetzt am DOM erkannt, ob teeinblue auf diesem
  // Produkt überhaupt arbeitet: die Galerie .tee-gallery-content und das
  // Formular #tee-artwork-form legt ausschliesslich teeinblue an. Beides
  // kommt per JavaScript und ist beim DOMContentLoaded noch nicht da,
  // deshalb wird darauf gewartet statt sofort entschieden.
  //
  // Auf Produkten ohne Kampagne laeuft der Beobachter ins Zeitlimit und
  // es passiert nichts — wichtig, denn sonst stuende dort ein Zoom-Knopf,
  // der nichts zu zeigen hat.
  //
  // Das Zeitlimit ist bewusst grosszuegig: teeinblue laedt seine
  // Kampagnendaten ueber das Netz, auf einer langsamen Mobilverbindung
  // dauert das. Lieber ein paar Sekunden laenger beobachten als die
  // Vorschau auf genau den Geraeten verlieren, fuer die sie gedacht ist.
  // ============================================================
  const TEEINBLUE_TIMEOUT_MS = 20000;

  const teeinblueBereit = () =>
    !!getGalleryContent() && !!document.querySelector("#tee-artwork-form");

  const warteAufTeeinblue = () => {
    if (teeinblueBereit()) {
      starten();
      return;
    }

    let fertig = false;

    const beobachter = new MutationObserver(() => {
      if (fertig || !teeinblueBereit()) return;
      fertig = true;
      beobachter.disconnect();
      starten();
    });

    beobachter.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      if (fertig) return;
      fertig = true;
      beobachter.disconnect();
    }, TEEINBLUE_TIMEOUT_MS);
  };

  warteAufTeeinblue();
});
